import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-12.0.1974-season-nine",
  buildId: '12.0.1974',
  name: "Season Nine Update",
  season: 9,
  type: "update",
  officialUrl: "https://www.ageofempires.com/news/age-of-empires-iv-season-nine-update-preview-12-0-1974/",
  summary: "Siege Rework...",
  introduction: `
![](https://cdn.ageofempires.com/aoe/wp-content/uploads/2024/10/Season_9_Event_Update_Banner-1080x608.webp)
"October brings both tricks and treats to Age of Empires IV with the upcoming Season Nine Update – coming October 22nd! Our seasonal biome Hallow’s Hearth makes a return, and with it comes a fun (or frightening) twist on the wolf unit with the Full Moon game mode. Not only that, but we’re officially launching Multiplayer Pause, along with a bundle of balance changes, there’s also two new maps arriving with this update."`,
  date: new Date("2024-10-22T17:00:00Z"),
  sections: [

  ],
};
